import { useFormikContext } from 'formik'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getFundingCurrencySelectField,
  isVisibleFundingFormField,
} from '@pages/Traders-Room/shared/hooks/useFundingCurrencySelector'

import { isFormFieldKnownType } from '@global/formField/formFieldsFactory/FormFieldComponentType'
import { FormFieldsFactory } from '@global/formField/formFieldsFactory/FormFieldsFactory'

import { Box } from '@shared/components/Box'

import { DepositFormValues } from '../DepositFlowLayout/types'

const NAME_OF_ACCOUNT_SNAKE = 'name_of_account'

export const DepositFormFields: React.FC = () => {
  const { values } = useFormikContext<DepositFormValues>()
  const { t } = useTranslation()

  const provider = values?.paymentProvider
  const rawFields = useMemo(
    () => provider?.parameters?.fields ?? [],
    [provider?.parameters?.fields]
  )

  const fundingCurrencyFieldName = getFundingCurrencySelectField(rawFields)?.name

  const fields = useMemo(() => {
    return rawFields
      .filter((field) => isVisibleFundingFormField(field, fundingCurrencyFieldName))
      .filter(isFormFieldKnownType)
      .map((field) => {
        const isNameOfAccount =
          field.name.endsWith(NAME_OF_ACCOUNT_SNAKE) || field.name.endsWith('nameOfAccount')

        return isNameOfAccount ? { ...field, label: t('Cardholder Name') } : field
      })
  }, [rawFields, fundingCurrencyFieldName, t])

  if (!fields.length) return null

  return (
    <Box fullWidth>
      <FormFieldsFactory fields={fields} />
    </Box>
  )
}
